import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';
import { TableColumn } from '../../models/table-column.model';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'cosmos-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [V2ButtonComponent, MatMenuTrigger, MatMenu, TranslatePipe]
})
export class DataTableComponent {
  readonly columns = input<TableColumn[]>(undefined);
  readonly sortedBy = input<string>(undefined);

  @Output() sortBy = new EventEmitter<{ key: string; direction: string }>();

  public sort(key: string, direction: string): void {
    this.sortBy.emit({ key, direction });
  }
}
